module.exports = __webpack_public_path__ + "static/media/pay.c25a7aad.svg";